import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { StockableStateModel } from './stockable.model'
import { StockableService } from '../stockable.service'
import { GetAllStockable, ReplaceStockables } from './stockable.actions'

@State<StockableStateModel>({
  name: 'stockable'
})
@Injectable()
export class StockableState {
  constructor(private stockableService: StockableService) {}

  @Selector()
  static allStockables(state: StockableStateModel) {
    return state.allStockables ?? []
  }

  @Action(GetAllStockable)
  getAllStockable(ctx: StateContext<StockableStateModel>, { locationId }: GetAllStockable) {
    ctx.patchState({
      allStockables: undefined
    })
    return this.stockableService.getAllStockables(locationId).pipe(
      tap((res) => {
        ctx.patchState({
          allStockables: res?.items ?? []
        })
      })
    )
  }

  @Action(ReplaceStockables)
  replaceStockables(ctx: StateContext<StockableStateModel>) {
    return this.stockableService.replaceStockables()
  }
}
